<template lang="pug">
    form(@submit.prevent)
        section.mb-5(title="Персональные данные")
            .mb-5.rounded-2xl.border.px-4.py-3.text-sm.leading-5(style="background-color: #FFF6D8; border-color: #E4C96A; color: #3F3A2A;")
                | Нам нужны ваши данные, так как по закону мы выступаем налоговым агентом и обязаны уплатить налоги с вашего дохода. Без этих сведений мы не сможем выполнить требования законодательства и выдать вам выигранный приз.
            .flex.flex-col
                label(for="lastname" class="text-sm mb-2") {{FORM_LABELS.lastname}}
                input(
                    type="text" 
                    id="lastname" 
                    v-model="form.lastname"
                    maxlength="100"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
            
            .flex.flex-col
                label(for="firstname" class="text-sm mb-2") {{FORM_LABELS.firstname}}
                input(
                    type="text" 
                    id="firstname" 
                    v-model="form.firstname"
                    maxlength="100"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
            
            .flex.flex-col
                label(for="patronymic" class="text-sm mb-2") {{FORM_LABELS.patronymic}}
                input(
                    type="text" 
                    id="patronymic" 
                    v-model="form.patronymic"
                    maxlength="100"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
                
        section.mb-5(title="Адрес")
            .flex.flex-col
                label(class="text-sm mb-2") {{FORM_LABELS.city}}
                .custom-select
                    select-option(
                        :options="LOCATIONS" 
                        @value="onLocation" 
                        :predefined="form.location.city"
                        class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                    )
            template(v-if="form.location.city === LOCATIONS.find(l => { return l.value === 2  }).name")
                .flex.justify-between
                    .flex.flex-col
                        label(for="area_code" class="text-sm mb-2") {{FORM_LABELS.area_code}}
                        input(
                            type="text" 
                            id="area_code" 
                            v-model="form.location.area_code" 
                            maxlength="6"
                            v-mask="'######'"
                            class="w-130 pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                        )
                    .flex.flex-col
                        label(for="other-city" class="text-sm mb-2") {{FORM_LABELS.settlement_name}}
                        input(
                            type="text" 
                            id="other-city" 
                            v-model="form.location.other_city"
                            maxlength="100"
                            class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                        )
                .flex.flex-col
                    label(for="street" class="text-sm mb-2") {{FORM_LABELS.street}}
                    input(
                        type="text" 
                        id="street" 
                        v-model="form.location.street"
                        maxlength="100"
                        class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                    )
                .flex.gap-5
                    .flex.flex-col
                        label(for="house_body" class="text-sm mb-2") {{FORM_LABELS.house_body}}
                        input(
                            type="text" 
                            id="house_body" 
                            v-model="form.location.house_body"
                            maxlength="20"
                            class="w-full pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                        )
                    .flex.flex-col
                        label(for="building" class="text-sm mb-2") {{FORM_LABELS.building}}
                        input(
                            type="text" 
                            id="building" 
                            v-model="form.location.building"
                            maxlength="20"
                            class="w-full pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                        )
                    .flex.flex-col
                        label(for="apartment" class="text-sm mb-2") {{FORM_LABELS.apartment}}
                        input(
                            type="text" 
                            id="apartment" 
                            v-model="form.location.apartment"
                            maxlength="20"
                            class="w-full pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                        )
            
            template(v-if="form.location.city === LOCATIONS.find(l => { return l.value === 1  }).name")
                app-notification.relative
                    span В Москве вы можете забрать подарок по адресу: {{MOSCOW_ADDRESS}}
                    img.absolute.right-5.cursor-pointer(
                        :src="IMAGES.clipboard" 
                        title="Копировать адрес" 
                        @click="copyToClipboard({ value: MOSCOW_ADDRESS })"
                    )

        //- .flex.flex-col.mb-5
        //-     label(for="phone" class="text-sm mb-2") {{FORM_LABELS.phone}}
        //-     input(
        //-         type="text" 
        //-         id="phone" 
        //-         v-model="form.phone" 
        //-         v-mask="'+#(###) ### ##-##'"
        //-         class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
        //-     )
        
        .flex.flex-col
            label(for="inn" class="text-sm mb-2") {{FORM_LABELS.inn}}
            input(
                type="text"
                id="inn"
                v-model="form.inn"
                maxlength="12"
                v-mask="'############'"
                class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
            )
        
        .flex.flex-col
            label(for="email" class="text-sm mb-2") {{FORM_LABELS.email}}
            input(
                ref="email"
                type="text" 
                id="email" 
                v-model="form.email"
                maxlength="100"
                class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
            )
        
        
        section(title="Паспорт" class="mb-5")
            .flex.gap-5.mb-5
                .flex.flex-col
                    label(for="passport.series" class="text-sm mb-2") {{FORM_LABELS.passport.series}}
                    input(
                        type="text" 
                        id="passport.series" 
                        v-model="form.passport.series" 
                        v-mask="'XXXX'"
                        class="w-full pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                    )
                .flex.flex-col
                    label(for="passport.number" class="text-sm mb-2") {{FORM_LABELS.passport.number}}
                    input(
                        type="text" 
                        id="passport.number" 
                        v-model="form.passport.number" 
                        v-mask="'######'"
                        class="w-full pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                    )
            .flex.flex-col
                label(for="passport.issued_date" class="text-sm mb-2") {{FORM_LABELS.passport.issued_date}}
                date-picker.mb-5(
                    v-model="form.passport.issued_date"
                    type="date"
                    format="DD.MM.YYYY"
                    value-type="date"
                    :lang="datePickerLang"
                    placeholder="дд.мм.гггг"
                    input-class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow w-full"
                )
            .flex.flex-col
                label(for="passport.issued_by" class="text-sm mb-2") {{FORM_LABELS.passport.issued_by}}
                input(
                    type="text"
                    id="passport.issued_by"
                    v-model="form.passport.issued_by"
                    maxlength="200"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
            .flex.flex-col
                label(for="passport.subdivision_code" class="text-sm mb-2") {{FORM_LABELS.passport.subdivision_code}}
                input(
                    type="text"
                    id="passport.subdivision_code"
                    v-model="form.passport.subdivision_code"
                    v-mask="'###-###'"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
            .flex.flex-col
                label(for="passport.registration_address" class="text-sm mb-2") {{FORM_LABELS.passport.registration_address}}
                input(
                    type="text"
                    id="passport.registration_address"
                    v-model="form.passport.registration_address"
                    maxlength="300"
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                )
            .file-upload(class="flex flex-col justify-between items-center gap-2 mb-10 w-[300px]")
                label(
                    class="custom-file-upload text-xs h-10 rounded-full px-5 w-full"
                    :class="getButtonColor()"
                    title="jpg, png или pdf, не более 10mb"
                ) {{ fileIsLoading ? '...идет загрузка' : FORM_LABELS.passport.photo_upload.toUpperCase() }}
                    input.form-file.w-full(type="file" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf" @input="onPassportCover($event)")
                template(v-if="files && files[0] && files[0].name")
                    img(v-if="passport_cover_img" :src="passport_cover_img")
                    span.block.text-xs.text-gray-500 {{onFormatFileName(files[0].name)}}
            
            .file-upload(class="flex flex-col justify-between items-center gap-2 w-[300px]")
                label(
                    class="custom-file-upload text-xs h-10 rounded-full px-5 w-full"
                    :class="getButtonColor()"
                    title="jpg, png или pdf, не более 10mb"
                ) {{ fileIsLoading ? '...идет загрузка' : FORM_LABELS.passport.photo_registration_upload.toUpperCase() }}
                    input.form-file.w-full(type="file" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf" @input="onPassportRegistrationCover($event)")
                template(v-if="files_registration && files_registration[0] && files_registration[0].name")
                    img(v-if="passport_registration_img" :src="passport_registration_img")
                    span.block.text-xs.text-gray-500 {{onFormatFileName(files_registration[0].name)}}
                            
        section.mt-10(title="Документы")
            app-checkbox.mb-2(@value="onEventConditions")
                a.text-sm.ml-3.cursor-pointer.medium-font(
                    v-if="rulesUrl"
                    :href="rulesUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click.stop
                ) {{FORM_LABELS.event_conditions}}
                span.text-sm.ml-3.medium-font(v-else) {{FORM_LABELS.event_conditions}}

            app-checkbox.mb-2(@value="onProcessingAgreement")
                a.text-sm.ml-3.cursor-pointer.medium-font(href="/" target="blank") {{FORM_LABELS.personal_data_processing_agreement}}
            
            app-checkbox.mb-2(@value="onShareAgreement")
                a.text-sm.ml-3.cursor-pointer.medium-font(href="/" target="blank") {{FORM_LABELS.personal_data_share_agreement}}
        
        .flex.flex-col.items-center.w-full.mt-10.mb-10
            app-button.w-250(:loading="isLoading" @click="onSend($data)")
                template {{ FORM_BUTTONS.send }}
            button.mt-4.text-sm.underline.cursor-pointer.medium-font(type="button" @click="onLogout") выход
</template>

<script>
//Components
import SelectOption from '@/components/common/select'
import Checkbox from '@/components/common/checkbox'
import Button from '@/components/common/button'
import Notification from '@/components/common/notifications'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
//Config
import { FORM_LABELS, FORM_BUTTONS } from '@/configs/forms'
//Mixins
import { _onFileUpload_ } from '@/mixins/files'
//Store
import { ProfileNameSpace, ProfileActionTypes } from '@/store/profile/types';
import { RootGetterTypes } from '@/store/types';
import { AuthorizationNameSpace, AuthorizationActionTypes } from '@/store/authorization/types';
//Helpers
import { copyToClipboard } from '@/helpers/copy-to-clipboard'
import { notifyError } from '@/helpers/notifications'
import { clearUserAuthData, clearUserLoginStatus } from '@/helpers/authorization'

export default {
    name: "profile-form",
    mixins: [_onFileUpload_],
    components: {
        'select-option': SelectOption,
        'app-checkbox': Checkbox,
        'app-button': Button,
        'app-notification': Notification,
        'date-picker': DatePicker,
    },
    data() {
        return {
            form: {
                lastname: '',
                firstname: '',
                patronymic: '',
                location: {
                    city: '',
                    other_city: '',
                    area_code: '',
                    street: '',
                    building: '',
                    apartment: '',
                    house_body: '',
                },
                phone: '',
                email: '',
                inn: '',
                passport: {
                    series: '',
                    number: '',
                    issued_date: null,
                    issued_by: '',
                    subdivision_code: '',
                    registration_address: '',
                    photo: '',
                    photo_registration: '',
                },
                personal_data_processing_agreement: false,
                personal_data_share_agreement: false,
                contract_offer_agreement: false,
            },
            files: [],
            passport_cover_img: '',
            files_registration: [],
            passport_registration_img: '',
            isLoading: false,
            fileIsLoading: false,
            // isValid: true,
            // validation_text: 'Проверьте правильность заполнения полей',
        }
    },
    computed: {
        FORM_LABELS() {
            return FORM_LABELS
        },
        FORM_BUTTONS() {
            return FORM_BUTTONS
        },
        rulesUrl() {
            const profile = this.$store.state.profile && this.$store.state.profile.profile
            const url = profile && profile.rules_url
            if (!url || !/^https?:\/\//i.test(String(url))) {
                return ''
            }
            return String(url)
        },
        IMAGES() {
            return {
                clipboard: require('@/static/icons/clipboard.svg')
            }
        },
        LOCATIONS() {
            return [
                {name: 'Москва', value: 1},
                {name: 'Другой населенный пункт', value: 2},
            ]
        },
        MOSCOW_ADDRESS() {
            return '123298, г.Москва, ул.3-я Хорошевская, д.12'
        },
        SETTINGS() {
            return this.$store.getters[`${RootGetterTypes.GetSettings}`]
        },
        datePickerLang() {
            return {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
                monthBeforeYear: false,
            }
        },
    },
    methods: {
        notifyError({title}) {
            return notifyError({title})
        },
        copyToClipboard({value}) {
            return copyToClipboard({value})
        },
        onLocation(value) {
            this.form.location.city = value
        },
        onEventConditions(value) {
            this.form.contract_offer_agreement = value
        },
        onProcessingAgreement(value) {
            this.form.personal_data_processing_agreement = value
        },
        onShareAgreement(value) {
            this.form.personal_data_share_agreement = value
        },
        isPassportFile(file) {
            const subtype = (file.type && file.type.split('/')[1] || '').toLowerCase()
            const name = (file.name || '').toLowerCase()
            return ['png', 'jpg', 'jpeg', 'pdf'].includes(subtype) || name.endsWith('.pdf')
        },
        isImageFile(file) {
            const subtype = (file.type && file.type.split('/')[1] || '').toLowerCase()
            return ['png', 'jpg', 'jpeg'].includes(subtype)
        },
        async onFile({ target, type = 'files'}) {
            const file = target.files[0]
            if (!file) {
                return null
            }
            if (!this.isPassportFile(file)) {
                this.notifyError({ title: 'Файл может быть только в формате .jpg, .png или .pdf' })
                return null
            }
            if (file.size > 10000000) {
                this.notifyError({ title: 'Файл не может быть больше 10mb' })
                return null
            }
            this.fileIsLoading = true
            this[type] = target.files
            await this._onFileUpload_({field: type})
            this.fileIsLoading = false
            return this._loadedFile_._id
        },
        async onPassportCover({target}) {
            const id = await this.onFile({target});
            if (this.isImageFile(target.files[0])) {
                this.passport_cover_img = URL.createObjectURL(target.files[0])
            } else {
                this.passport_cover_img = ''
            }
            if (id) {
                this.form.passport.photo = id
            }
            else return;
        },
        async onPassportRegistrationCover({target}) {
            const id = await this.onFile({target: target, type: 'files_registration'});
            if (this.isImageFile(target.files[0])) {
                this.passport_registration_img = URL.createObjectURL(target.files[0])
            } else {
                this.passport_registration_img = ''
            }
            if (id) {
                this.form.passport.photo_registration = id
            }
            else return;
        },
        async onLogout() {
            try {
                await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.Logout}`)
            } finally {
                clearUserAuthData()
                clearUserLoginStatus()
                window.location.assign('/')
            }
        },
        onSend({ form }) {
            if (!this.isLoading) {
                this.isLoading = true
                this.$store.dispatch(`${ProfileNameSpace}/${ProfileActionTypes.AddProfile}`, { 
                    data: {
                        ...form,
                        location: {
                            ...form.location,
                            city: form.location.other_city ? form.location.other_city : form.location.city
                        },
                        phone: form.phone.replace(/\D+/g, ''),
                        passport: {
                            ...form.passport,
                            issued_date: this.formatIssuedDate(form.passport.issued_date),
                        },
                    }
                })
                .then(response => {
                    if (response && response.data && response.data.statusCode === 201) {
                        window.location.reload()
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
                
            }
        },
        getButtonColor() {
            return this.SETTINGS.file_upload_button
        },  
        formatIssuedDate(value) {
            if (!value) {
                return ''
            }
            const date = value instanceof Date ? value : new Date(value)
            if (Number.isNaN(date.getTime())) {
                return ''
            }
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        onFormatFileName(name) {
            let result = name;
            if (name.length > 20) {
                const arr = name.split('.')
                const words_arr = arr[0].slice(0, 15)
                result = `${words_arr}... .${arr[arr.length - 1]}`
            }
            return result
        },
        // onEmailValidation(email) {
        //     let regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
        //     return regex.test(email)
        // }
    },
    watch: {
        'form.location.city': {
            handler(value) {
                if (value === this.LOCATIONS.find(l => { return l.value === 1  }).name) {
                    this.form.location.other_city = ''
                    this.form.location.area_code = ''
                    this.form.location.street = ''
                    this.form.location.building = ''
                    this.form.location.apartment = ''
                    this.form.location.house_body = ''
                }
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.file-upload
    input[type="file"]
        display: none
    .custom-file-upload
        box-sizing: border-box
        cursor: pointer
        display: flex
        justify-content: center
        align-items: center
        color: #ffffff
        &::before
            content: ''
            width: 20px
            height: 15px
            background-image: url('../assets/camera.svg')
            background-size: contain
            margin-right: 10px
            margin-bottom: 3px
    .custom-file-upload-black
        color: #000
        &::before
            background-image: url('../assets/camera-black.svg')
            

.custom-select
    position: relative
    &::after
        position: absolute
        content: ''
        width: 15px
        height: 15px
        right: 15px
        top: 15px
        background-image: url('../../../../static/icons/chevron-down.svg')
        background-size: contain

.medium-font
    cursor: pointer
    transition: color 0.25s ease
    &:hover
        color: #6a6a6a

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance: none
  margin: 0


/* Firefox */
input[type=number]
  -moz-appearance: textfield
</style>